var map = {
	"./de/intros/NonWOrdInstruction.mp3": 46586,
	"./de/intros/SM_Intro-AFTER-trial.mp3": 18828,
	"./de/intros/letterKnowledge-intro.mp3": 26954,
	"./de/intros/oneMinute-intro-adult.mp3": 3309,
	"./de/intros/oneMinute-intro-child.mp3": 45047,
	"./de/intros/pd-intro-child.mp3": 79141,
	"./de/intros/pd-intro.mp3": 18980,
	"./de/intros/pd_intro_done.mp3": 9721,
	"./de/intros/phonemeIsolation-klarte-oppgaver.mp3": 51692,
	"./de/intros/phonemeIsolation-starter-intro.mp3": 31636,
	"./de/intros/rapidNaming-intro1_child.mp3": 67554,
	"./de/intros/setningsminne-intro.mp3": 26358,
	"./de/intros/spoonerismAdult.mp3": 13166,
	"./de/intros/test-is-starting.mp3": 97291,
	"./de/intros/testen-er-ferdig.mp3": 63488,
	"./de/intros/testen-ferdig-child.mp3": 73101,
	"./de/intros/workingmemory-numbers-intro-adult.mp3": 71100,
	"./de/intros/workingmemory-numbers-intro.mp3": 75903,
	"./de/intros/workingmemory-words-intro-adult.mp3": 67433,
	"./de/intros/workingmemory-words-intro-child.mp3": 55139,
	"./de/intros/workingmemory-words-intro.mp3": 14854,
	"./de/nonwordRepetition/FOL-A-054.mp3": 40753,
	"./de/pauses/FOL-C-006.mp3": 44901,
	"./de/pauses/FOL-C-013.mp3": 50787,
	"./de/pauses/SCR-A-007.mp3": 26301,
	"./de/pauses/SCR007-child.mp3": 55723,
	"./de/pauses/minChild.mp3": 18395,
	"./de/pauses/pd-finish-sound.mp3": 14845,
	"./de/pauses/rapidnaming.mp3": 17601,
	"./de/phonemeDeletion/alt-t.mp3": 14790,
	"./de/phonemeDeletion/bau-ch.mp3": 40044,
	"./de/phonemeDeletion/bauch-child.mp3": 17504,
	"./de/phonemeDeletion/bauch.mp3": 36781,
	"./de/phonemeDeletion/brev-b.mp3": 38492,
	"./de/phonemeDeletion/brev.mp3": 72793,
	"./de/phonemeDeletion/bro-r.mp3": 45982,
	"./de/phonemeDeletion/bro.mp3": 32015,
	"./de/phonemeDeletion/broed-b.mp3": 59833,
	"./de/phonemeDeletion/broed.mp3": 20696,
	"./de/phonemeDeletion/brot-r.mp3": 99276,
	"./de/phonemeDeletion/brus-b.mp3": 47593,
	"./de/phonemeDeletion/bry-r.mp3": 56124,
	"./de/phonemeDeletion/bry.mp3": 23497,
	"./de/phonemeDeletion/dansk-k.mp3": 84707,
	"./de/phonemeDeletion/decke-d.mp3": 74219,
	"./de/phonemeDeletion/drap-d.mp3": 42478,
	"./de/phonemeDeletion/drap.mp3": 45397,
	"./de/phonemeDeletion/eis-r.mp3": 2008,
	"./de/phonemeDeletion/eis-s.mp3": 8381,
	"./de/phonemeDeletion/film-m.mp3": 28788,
	"./de/phonemeDeletion/foere-f.mp3": 53972,
	"./de/phonemeDeletion/foere.mp3": 34525,
	"./de/phonemeDeletion/frisch-r.mp3": 30904,
	"./de/phonemeDeletion/gaas-g.mp3": 77444,
	"./de/phonemeDeletion/gaas.mp3": 23908,
	"./de/phonemeDeletion/glas-l.mp3": 58346,
	"./de/phonemeDeletion/graben-r.mp3": 30854,
	"./de/phonemeDeletion/gris-g.mp3": 22659,
	"./de/phonemeDeletion/gris.mp3": 57275,
	"./de/phonemeDeletion/hans-s.mp3": 45920,
	"./de/phonemeDeletion/haus-h.mp3": 80930,
	"./de/phonemeDeletion/helst-l.mp3": 84313,
	"./de/phonemeDeletion/klaer-k.mp3": 99807,
	"./de/phonemeDeletion/klaer.mp3": 29195,
	"./de/phonemeDeletion/klart-t.mp3": 55163,
	"./de/phonemeDeletion/klatre-t.mp3": 1090,
	"./de/phonemeDeletion/klatre.mp3": 71769,
	"./de/phonemeDeletion/knopf-child.mp3": 31565,
	"./de/phonemeDeletion/knopf-n.mp3": 22153,
	"./de/phonemeDeletion/knopf.mp3": 53260,
	"./de/phonemeDeletion/kopf-n.mp3": 76061,
	"./de/phonemeDeletion/kran-r.mp3": 67883,
	"./de/phonemeDeletion/laas-s.mp3": 94141,
	"./de/phonemeDeletion/laas.mp3": 65421,
	"./de/phonemeDeletion/lekse-k.mp3": 54616,
	"./de/phonemeDeletion/lekse.mp3": 93596,
	"./de/phonemeDeletion/loff-f.mp3": 19698,
	"./de/phonemeDeletion/loff.mp3": 34511,
	"./de/phonemeDeletion/maal-m.mp3": 68247,
	"./de/phonemeDeletion/malt-l.mp3": 70957,
	"./de/phonemeDeletion/malt.mp3": 91966,
	"./de/phonemeDeletion/mars-r.mp3": 88342,
	"./de/phonemeDeletion/maus-m.mp3": 29416,
	"./de/phonemeDeletion/mond-m.mp3": 3112,
	"./de/phonemeDeletion/mund-m.mp3": 27214,
	"./de/phonemeDeletion/pris-p.mp3": 62153,
	"./de/phonemeDeletion/rechts-s.mp3": 90589,
	"./de/phonemeDeletion/reis-child.mp3": 33382,
	"./de/phonemeDeletion/reis.mp3": 95671,
	"./de/phonemeDeletion/riegel-r.mp3": 23509,
	"./de/phonemeDeletion/ris-r.mp3": 53027,
	"./de/phonemeDeletion/rot-t.mp3": 10964,
	"./de/phonemeDeletion/saal-s.mp3": 15911,
	"./de/phonemeDeletion/sel-l.mp3": 28727,
	"./de/phonemeDeletion/sel.mp3": 88008,
	"./de/phonemeDeletion/ser-r.mp3": 74947,
	"./de/phonemeDeletion/skyll-l.mp3": 47932,
	"./de/phonemeDeletion/skyll.mp3": 48963,
	"./de/phonemeDeletion/spoer-p.mp3": 84618,
	"./de/phonemeDeletion/sport-p.mp3": 74177,
	"./de/phonemeDeletion/sport.mp3": 23566,
	"./de/phonemeDeletion/stau-child.mp3": 91178,
	"./de/phonemeDeletion/stau-t-child.mp3": 53397,
	"./de/phonemeDeletion/stau-t.mp3": 88020,
	"./de/phonemeDeletion/stoev-s.mp3": 70821,
	"./de/phonemeDeletion/tap-p.mp3": 87496,
	"./de/phonemeDeletion/tekst-k.mp3": 53049,
	"./de/phonemeDeletion/tor-t.mp3": 35520,
	"./de/phonemeDeletion/trauen-t.mp3": 98090,
	"./de/phonemeDeletion/trygg-t.mp3": 50770,
	"./de/phonemeDeletion/trygg.mp3": 61929,
	"./de/phonemeDeletion/warm-m.mp3": 98833,
	"./de/rapidNaming/rapidNaming-intro1_adult.mp3": 15855,
	"./de/rapidNaming/rapidNaming-intro1_child.mp3": 82269,
	"./de/rapidNaming/rapidNaming-intro2_adult.mp3": 68364,
	"./de/rapidNaming/rapidNaming-intro2_child.mp3": 318,
	"./de/rapidNaming/rapidNaming-intro3_adult.mp3": 45529,
	"./de/rapidNaming/rapidNaming-intro3_child.mp3": 88819,
	"./de/rapidNaming/rapidNaming-intro4_adult.mp3": 74262,
	"./de/rapidNaming/rapidNaming-intro4_child.mp3": 48772,
	"./de/rapidNaming/rapidNaming-intro5_adult.mp3": 96675,
	"./de/rapidNaming/rapidNaming-intro5_child.mp3": 98945,
	"./de/spoonerism/correct-1.mp3": 26969,
	"./de/spoonerism/correct-2.mp3": 9606,
	"./de/spoonerism/correct-3.mp3": 48715,
	"./de/spoonerism/incorrect-1.mp3": 20858,
	"./de/spoonerism/incorrect-2.mp3": 92877,
	"./de/spoonerism/incorrect-3.mp3": 78216,
	"./de/spoonerism/intro-end.mp3": 55759,
	"./de/spoonerism/intro.mp3": 14791,
	"./de/spoonerism/proveoppgave-1.mp3": 48355,
	"./de/spoonerism/proveoppgave-2.mp3": 78188,
	"./de/spoonerism/proveoppgave-3.mp3": 52401,
	"./de/workingmemory_numbers/stop.mp3": 29157,
	"./de/workingmemory_numbers/wmTrial-numbers-1.mp3": 4084,
	"./de/workingmemory_numbers/wmTrial-numbers-2.mp3": 8523,
	"./de/workingmemory_numbers/wmTrial-numbers-3.mp3": 38,
	"./de/workingmemory_numbers/wmTrial-numbers-child-1.mp3": 76269,
	"./de/workingmemory_numbers/wmTrial-numbers-child-2.mp3": 73370,
	"./de/workingmemory_numbers/wmTrial-numbers-child-3.mp3": 86335,
	"./de/workingmemory_numbers/workingmemory-numbers-1.mp3": 70064,
	"./de/workingmemory_numbers/workingmemory-numbers-10.mp3": 56936,
	"./de/workingmemory_numbers/workingmemory-numbers-11.mp3": 30541,
	"./de/workingmemory_numbers/workingmemory-numbers-12.mp3": 97018,
	"./de/workingmemory_numbers/workingmemory-numbers-2.mp3": 135,
	"./de/workingmemory_numbers/workingmemory-numbers-3.mp3": 22626,
	"./de/workingmemory_numbers/workingmemory-numbers-4.mp3": 51985,
	"./de/workingmemory_numbers/workingmemory-numbers-5.mp3": 94124,
	"./de/workingmemory_numbers/workingmemory-numbers-6.mp3": 51939,
	"./de/workingmemory_numbers/workingmemory-numbers-7.mp3": 59998,
	"./de/workingmemory_numbers/workingmemory-numbers-8.mp3": 45002,
	"./de/workingmemory_numbers/workingmemory-numbers-9.mp3": 46872,
	"./de/workingmemory_numbers/workingmemory-numbers-adult-1.mp3": 22215,
	"./de/workingmemory_numbers/workingmemory-numbers-child-1.mp3": 33761,
	"./de/workingmemory_words/stop.mp3": 76774,
	"./de/workingmemory_words/wmTrial-words-1-child.mp3": 52213,
	"./de/workingmemory_words/wmTrial-words-1.mp3": 29748,
	"./de/workingmemory_words/wmTrial-words-2.mp3": 76715,
	"./de/workingmemory_words/wmTrial-words-3-adult.mp3": 17129,
	"./de/workingmemory_words/wmTrial-words-3-child.mp3": 4835,
	"./de/workingmemory_words/workingmemory-words-1.mp3": 31788,
	"./de/workingmemory_words/workingmemory-words-10.mp3": 65884,
	"./de/workingmemory_words/workingmemory-words-11.mp3": 1185,
	"./de/workingmemory_words/workingmemory-words-12.mp3": 97390,
	"./de/workingmemory_words/workingmemory-words-1_adult.mp3": 95517,
	"./de/workingmemory_words/workingmemory-words-1_child.mp3": 43879,
	"./de/workingmemory_words/workingmemory-words-2.mp3": 54979,
	"./de/workingmemory_words/workingmemory-words-3.mp3": 74686,
	"./de/workingmemory_words/workingmemory-words-4.mp3": 16469,
	"./de/workingmemory_words/workingmemory-words-5.mp3": 56688,
	"./de/workingmemory_words/workingmemory-words-6.mp3": 11623,
	"./de/workingmemory_words/workingmemory-words-7.mp3": 6690,
	"./de/workingmemory_words/workingmemory-words-8.mp3": 81753,
	"./de/workingmemory_words/workingmemory-words-9.mp3": 56532,
	"./nn/dictation/diktat-12.mp3": 59019,
	"./nn/dictation/diktat-13.mp3": 14598,
	"./nn/dictation/diktat-15.mp3": 51704,
	"./nn/dictation/diktat-16.mp3": 67951,
	"./nn/dictation/diktat-17.mp3": 89450,
	"./nn/dictation/diktat-19.mp3": 98956,
	"./nn/dictation/diktat-21.mp3": 53377,
	"./nn/dictation/diktat-24.mp3": 18272,
	"./nn/dictation/diktat-28.mp3": 34788,
	"./nn/dictation/diktat-35.mp3": 63810,
	"./nn/dictation/diktat-36.mp3": 89941,
	"./nn/dictation/diktat-38.mp3": 76971,
	"./nn/dictation/diktat-39.mp3": 21510,
	"./nn/dictation/diktat-intro.mp3": 35744,
	"./nn/intros/letterKnowledge-intro.mp3": 55109,
	"./nn/intros/oneMinute-intro.mp3": 549,
	"./nn/intros/pd-intro.mp3": 50461,
	"./nn/intros/phonemeIsolation-klarte-oppgaver.mp3": 61245,
	"./nn/intros/phonemeIsolation-starter-intro.mp3": 50657,
	"./nn/intros/testen-er-ferdig.mp3": 3205,
	"./nn/intros/workingmemory-numbers-intro.mp3": 93872,
	"./nn/intros/workingmemory-words-intro.mp3": 693,
	"./nn/phonemeDeletion/brev-b.mp3": 89263,
	"./nn/phonemeDeletion/brev.mp3": 93186,
	"./nn/phonemeDeletion/broed-b.mp3": 87248,
	"./nn/phonemeDeletion/bru-r.mp3": 23157,
	"./nn/phonemeDeletion/bry-r.mp3": 33737,
	"./nn/phonemeDeletion/drap-d.mp3": 80441,
	"./nn/phonemeDeletion/foere-f.mp3": 12625,
	"./nn/phonemeDeletion/foere.mp3": 98396,
	"./nn/phonemeDeletion/gaas-g.mp3": 22855,
	"./nn/phonemeDeletion/gris-g.mp3": 98152,
	"./nn/phonemeDeletion/gris.mp3": 75400,
	"./nn/phonemeDeletion/klatre-t.mp3": 97133,
	"./nn/phonemeDeletion/klede-k.mp3": 48834,
	"./nn/phonemeDeletion/laas-s.mp3": 898,
	"./nn/phonemeDeletion/lekse-k.mp3": 99341,
	"./nn/phonemeDeletion/loff-f.mp3": 69385,
	"./nn/phonemeDeletion/maal-m.mp3": 13896,
	"./nn/phonemeDeletion/malt-l.mp3": 80210,
	"./nn/phonemeDeletion/sel-l.mp3": 48762,
	"./nn/phonemeDeletion/sel.mp3": 93241,
	"./nn/phonemeDeletion/skyl-l.mp3": 43141,
	"./nn/phonemeDeletion/sport-p.mp3": 92988,
	"./nn/phonemeDeletion/trygg-t.mp3": 49407,
	"./nn/phonemeIsolation/ends_with_e.mp3": 83502,
	"./nn/phonemeIsolation/ends_with_i.mp3": 42490,
	"./nn/phonemeIsolation/ends_with_k.mp3": 99848,
	"./nn/phonemeIsolation/ends_with_n.mp3": 74217,
	"./nn/phonemeIsolation/ends_with_o.mp3": 39268,
	"./nn/phonemeIsolation/ends_with_p.mp3": 19751,
	"./nn/phonemeIsolation/ends_with_r.mp3": 86773,
	"./nn/phonemeIsolation/ends_with_t.mp3": 71555,
	"./nn/phonemeIsolation/ends_with_u.mp3": 79614,
	"./nn/phonemeIsolation/ends_with_y.mp3": 4234,
	"./nn/phonemeIsolation/starts_with_b.mp3": 31870,
	"./nn/phonemeIsolation/starts_with_e.mp3": 73653,
	"./nn/phonemeIsolation/starts_with_g.mp3": 52455,
	"./nn/phonemeIsolation/starts_with_h.mp3": 97364,
	"./nn/phonemeIsolation/starts_with_i.mp3": 22585,
	"./nn/phonemeIsolation/starts_with_k.mp3": 60683,
	"./nn/phonemeIsolation/starts_with_l.mp3": 70328,
	"./nn/phonemeIsolation/starts_with_oe.mp3": 13476,
	"./nn/phonemeIsolation/starts_with_s.mp3": 38611,
	"./nn/phonemeIsolation/starts_with_v.mp3": 9298,
	"./nn/rapidNaming/rapidNaming-intro1.mp3": 60697,
	"./nn/rapidNaming/rapidNaming-intro2.mp3": 806,
	"./nn/rapidNaming/rapidNaming-intro3.mp3": 9291,
	"./nn/rapidNaming/rapidNaming-intro4.mp3": 18936,
	"./nn/rapidNaming/rapidNaming-intro5.mp3": 31453,
	"./nn/spoonerism/correct-1.mp3": 36450,
	"./nn/spoonerism/correct-2.mp3": 73077,
	"./nn/spoonerism/correct-3.mp3": 86448,
	"./nn/spoonerism/incorrect-1.mp3": 91613,
	"./nn/spoonerism/incorrect-2.mp3": 37258,
	"./nn/spoonerism/incorrect-3.mp3": 15759,
	"./nn/spoonerism/intro-end.mp3": 71404,
	"./nn/spoonerism/intro.mp3": 84624,
	"./nn/spoonerism/proveoppgave-1.mp3": 34430,
	"./nn/spoonerism/proveoppgave-2.mp3": 10065,
	"./nn/spoonerism/proveoppgave-3.mp3": 52204,
	"./nn/spoonerism/spoonerism-task (1).mp3": 77391,
	"./nn/spoonerism/spoonerism-task (10).mp3": 97067,
	"./nn/spoonerism/spoonerism-task (11).mp3": 87048,
	"./nn/spoonerism/spoonerism-task (2).mp3": 97782,
	"./nn/spoonerism/spoonerism-task (3).mp3": 95289,
	"./nn/spoonerism/spoonerism-task (4).mp3": 60216,
	"./nn/spoonerism/spoonerism-task (5).mp3": 74011,
	"./nn/spoonerism/spoonerism-task (6).mp3": 45618,
	"./nn/spoonerism/spoonerism-task (7).mp3": 78741,
	"./nn/spoonerism/spoonerism-task (8).mp3": 61508,
	"./nn/spoonerism/spoonerism-task (9).mp3": 32055,
	"./nn/spoonerism/unk-spoonerism-task ().mp3": 11375,
	"./nn/workingmemory_numbers/workingmemory-numbers-1.mp3": 47605,
	"./nn/workingmemory_numbers/workingmemory-numbers-10.mp3": 54159,
	"./nn/workingmemory_numbers/workingmemory-numbers-11.mp3": 75658,
	"./nn/workingmemory_numbers/workingmemory-numbers-12.mp3": 30013,
	"./nn/workingmemory_numbers/workingmemory-numbers-2.mp3": 37826,
	"./nn/workingmemory_numbers/workingmemory-numbers-3.mp3": 26407,
	"./nn/workingmemory_numbers/workingmemory-numbers-4.mp3": 62924,
	"./nn/workingmemory_numbers/workingmemory-numbers-5.mp3": 78257,
	"./nn/workingmemory_numbers/workingmemory-numbers-6.mp3": 5822,
	"./nn/workingmemory_numbers/workingmemory-numbers-7.mp3": 86115,
	"./nn/workingmemory_numbers/workingmemory-numbers-8.mp3": 44280,
	"./nn/workingmemory_numbers/workingmemory-numbers-9.mp3": 14269,
	"./nn/workingmemory_words/workingmemory-words-1.mp3": 87913,
	"./nn/workingmemory_words/workingmemory-words-10.mp3": 25515,
	"./nn/workingmemory_words/workingmemory-words-11.mp3": 64742,
	"./nn/workingmemory_words/workingmemory-words-12.mp3": 80665,
	"./nn/workingmemory_words/workingmemory-words-2.mp3": 15958,
	"./nn/workingmemory_words/workingmemory-words-3.mp3": 8987,
	"./nn/workingmemory_words/workingmemory-words-4.mp3": 46152,
	"./nn/workingmemory_words/workingmemory-words-5.mp3": 93581,
	"./nn/workingmemory_words/workingmemory-words-6.mp3": 90682,
	"./nn/workingmemory_words/workingmemory-words-7.mp3": 87295,
	"./nn/workingmemory_words/workingmemory-words-8.mp3": 95740,
	"./nn/workingmemory_words/workingmemory-words-9.mp3": 23137,
	"./no/dictation/diktat-0.mp3": 98101,
	"./no/dictation/diktat-1.mp3": 11472,
	"./no/dictation/diktat-10.mp3": 25608,
	"./no/dictation/diktat-11.mp3": 70893,
	"./no/dictation/diktat-12.mp3": 25722,
	"./no/dictation/diktat-13.mp3": 18335,
	"./no/dictation/diktat-14.mp3": 53124,
	"./no/dictation/diktat-15.mp3": 88073,
	"./no/dictation/diktat-16.mp3": 41686,
	"./no/dictation/diktat-17.mp3": 9403,
	"./no/dictation/diktat-18.mp3": 53696,
	"./no/dictation/diktat-19.mp3": 98789,
	"./no/dictation/diktat-2.mp3": 66407,
	"./no/dictation/diktat-20.mp3": 14213,
	"./no/dictation/diktat-21.mp3": 38496,
	"./no/dictation/diktat-22.mp3": 93687,
	"./no/dictation/diktat-23.mp3": 46642,
	"./no/dictation/diktat-24.mp3": 38977,
	"./no/dictation/diktat-25.mp3": 46204,
	"./no/dictation/diktat-26.mp3": 6579,
	"./no/dictation/diktat-27.mp3": 24686,
	"./no/dictation/diktat-28.mp3": 55693,
	"./no/dictation/diktat-29.mp3": 57384,
	"./no/dictation/diktat-3.mp3": 61474,
	"./no/dictation/diktat-30.mp3": 51710,
	"./no/dictation/diktat-31.mp3": 32003,
	"./no/dictation/diktat-32.mp3": 8812,
	"./no/dictation/diktat-33.mp3": 24145,
	"./no/dictation/diktat-34.mp3": 67362,
	"./no/dictation/diktat-35.mp3": 72295,
	"./no/dictation/diktat-36.mp3": 17360,
	"./no/dictation/diktat-37.mp3": 93493,
	"./no/dictation/diktat-38.mp3": 25062,
	"./no/dictation/diktat-39.mp3": 64171,
	"./no/dictation/diktat-4.mp3": 71281,
	"./no/dictation/diktat-5.mp3": 13420,
	"./no/dictation/diktat-6.mp3": 83587,
	"./no/dictation/diktat-7.mp3": 98846,
	"./no/dictation/diktat-8.mp3": 7293,
	"./no/dictation/diktat-9.mp3": 94776,
	"./no/dictation/diktat-intro.mp3": 86747,
	"./no/intros/letterKnowledge-intro.mp3": 41138,
	"./no/intros/oneMinute-intro.mp3": 29434,
	"./no/intros/pd-intro.mp3": 3500,
	"./no/intros/phonemeIsolation-klarte-oppgaver.mp3": 61700,
	"./no/intros/phonemeIsolation-starter-intro.mp3": 22508,
	"./no/intros/testen-er-ferdig.mp3": 47592,
	"./no/intros/workingmemory-numbers-intro.mp3": 70279,
	"./no/intros/workingmemory-words-intro.mp3": 92190,
	"./no/phonemeDeletion/brev-b.mp3": 17748,
	"./no/phonemeDeletion/brev.mp3": 11073,
	"./no/phonemeDeletion/bro-r.mp3": 7926,
	"./no/phonemeDeletion/bro.mp3": 23255,
	"./no/phonemeDeletion/broed-b.mp3": 5873,
	"./no/phonemeDeletion/broed.mp3": 25600,
	"./no/phonemeDeletion/brus-b.mp3": 44993,
	"./no/phonemeDeletion/bry-r.mp3": 63668,
	"./no/phonemeDeletion/bry.mp3": 87569,
	"./no/phonemeDeletion/dansk-k.mp3": 32283,
	"./no/phonemeDeletion/drap-d.mp3": 10790,
	"./no/phonemeDeletion/drap.mp3": 74397,
	"./no/phonemeDeletion/film-m.mp3": 79756,
	"./no/phonemeDeletion/foere-f.mp3": 35820,
	"./no/phonemeDeletion/foere.mp3": 88421,
	"./no/phonemeDeletion/gaas-g.mp3": 69660,
	"./no/phonemeDeletion/gaas.mp3": 75436,
	"./no/phonemeDeletion/gris-g.mp3": 58507,
	"./no/phonemeDeletion/gris.mp3": 13875,
	"./no/phonemeDeletion/hans-s.mp3": 47947,
	"./no/phonemeDeletion/helst-l.mp3": 29777,
	"./no/phonemeDeletion/klaer-k.mp3": 63735,
	"./no/phonemeDeletion/klaer.mp3": 63107,
	"./no/phonemeDeletion/klart-t.mp3": 15235,
	"./no/phonemeDeletion/klatre-t.mp3": 25050,
	"./no/phonemeDeletion/klatre.mp3": 47873,
	"./no/phonemeDeletion/laas-s.mp3": 95941,
	"./no/phonemeDeletion/laas.mp3": 84293,
	"./no/phonemeDeletion/lekse-k.mp3": 19504,
	"./no/phonemeDeletion/lekse.mp3": 26260,
	"./no/phonemeDeletion/loff-f.mp3": 71146,
	"./no/phonemeDeletion/loff.mp3": 72439,
	"./no/phonemeDeletion/maal-m.mp3": 90719,
	"./no/phonemeDeletion/malt-l.mp3": 46229,
	"./no/phonemeDeletion/malt.mp3": 33766,
	"./no/phonemeDeletion/mars-r.mp3": 81790,
	"./no/phonemeDeletion/pris-p.mp3": 13169,
	"./no/phonemeDeletion/ris-r.mp3": 31643,
	"./no/phonemeDeletion/sel-l.mp3": 28127,
	"./no/phonemeDeletion/sel.mp3": 89584,
	"./no/phonemeDeletion/ser-r.mp3": 89163,
	"./no/phonemeDeletion/skyll-l.mp3": 90068,
	"./no/phonemeDeletion/skyll.mp3": 23611,
	"./no/phonemeDeletion/spoer-p.mp3": 56162,
	"./no/phonemeDeletion/sport-p.mp3": 54937,
	"./no/phonemeDeletion/sport.mp3": 32662,
	"./no/phonemeDeletion/stoev-s.mp3": 69341,
	"./no/phonemeDeletion/tap-p.mp3": 71568,
	"./no/phonemeDeletion/tekst-k.mp3": 66945,
	"./no/phonemeDeletion/trygg-t.mp3": 19178,
	"./no/phonemeDeletion/trygg.mp3": 83601,
	"./no/phonemeIsolation/ends_with_e.mp3": 70321,
	"./no/phonemeIsolation/ends_with_i.mp3": 6333,
	"./no/phonemeIsolation/ends_with_k.mp3": 70863,
	"./no/phonemeIsolation/ends_with_n.mp3": 59334,
	"./no/phonemeIsolation/ends_with_o.mp3": 67819,
	"./no/phonemeIsolation/ends_with_p.mp3": 99232,
	"./no/phonemeIsolation/ends_with_r.mp3": 58962,
	"./no/phonemeIsolation/ends_with_t.mp3": 11388,
	"./no/phonemeIsolation/ends_with_u.mp3": 8161,
	"./no/phonemeIsolation/ends_with_y.mp3": 51757,
	"./no/phonemeIsolation/starts_with_b.mp3": 18065,
	"./no/phonemeIsolation/starts_with_e.mp3": 84258,
	"./no/phonemeIsolation/starts_with_g.mp3": 48048,
	"./no/phonemeIsolation/starts_with_h.mp3": 15819,
	"./no/phonemeIsolation/starts_with_i.mp3": 59494,
	"./no/phonemeIsolation/starts_with_k.mp3": 11124,
	"./no/phonemeIsolation/starts_with_l.mp3": 24751,
	"./no/phonemeIsolation/starts_with_oe.mp3": 64881,
	"./no/phonemeIsolation/starts_with_s.mp3": 51484,
	"./no/phonemeIsolation/starts_with_v.mp3": 15045,
	"./no/rapidNaming/rapidNaming-intro1.mp3": 78906,
	"./no/rapidNaming/rapidNaming-intro2.mp3": 12429,
	"./no/rapidNaming/rapidNaming-intro3.mp3": 38824,
	"./no/rapidNaming/rapidNaming-intro4.mp3": 13563,
	"./no/rapidNaming/rapidNaming-intro5.mp3": 34806,
	"./no/spoonerism/correct-1.mp3": 13393,
	"./no/spoonerism/correct-2.mp3": 40958,
	"./no/spoonerism/correct-3.mp3": 9347,
	"./no/spoonerism/incorrect-1.mp3": 4914,
	"./no/spoonerism/incorrect-2.mp3": 11813,
	"./no/spoonerism/incorrect-3.mp3": 45184,
	"./no/spoonerism/intro-end.mp3": 70487,
	"./no/spoonerism/intro.mp3": 27215,
	"./no/spoonerism/proveoppgave-1.mp3": 91643,
	"./no/spoonerism/proveoppgave-2.mp3": 44676,
	"./no/spoonerism/proveoppgave-3.mp3": 58665,
	"./no/spoonerism/spoonerism-task (1).mp3": 40096,
	"./no/spoonerism/spoonerism-task (10).mp3": 4154,
	"./no/spoonerism/spoonerism-task (11).mp3": 44669,
	"./no/spoonerism/spoonerism-task (12).mp3": 18176,
	"./no/spoonerism/spoonerism-task (13).mp3": 44835,
	"./no/spoonerism/spoonerism-task (14).mp3": 20798,
	"./no/spoonerism/spoonerism-task (15).mp3": 28321,
	"./no/spoonerism/spoonerism-task (16).mp3": 1572,
	"./no/spoonerism/spoonerism-task (17).mp3": 33975,
	"./no/spoonerism/spoonerism-task (18).mp3": 20562,
	"./no/spoonerism/spoonerism-task (19).mp3": 54293,
	"./no/spoonerism/spoonerism-task (2).mp3": 95549,
	"./no/spoonerism/spoonerism-task (20).mp3": 49861,
	"./no/spoonerism/spoonerism-task (3).mp3": 43386,
	"./no/spoonerism/spoonerism-task (4).mp3": 68599,
	"./no/spoonerism/spoonerism-task (5).mp3": 98052,
	"./no/spoonerism/spoonerism-task (6).mp3": 58689,
	"./no/spoonerism/spoonerism-task (7).mp3": 48126,
	"./no/spoonerism/spoonerism-task (8).mp3": 94203,
	"./no/spoonerism/spoonerism-task (9).mp3": 80408,
	"./no/workingmemory_numbers/workingmemory-numbers-1.mp3": 4984,
	"./no/workingmemory_numbers/workingmemory-numbers-10.mp3": 17952,
	"./no/workingmemory_numbers/workingmemory-numbers-11.mp3": 84581,
	"./no/workingmemory_numbers/workingmemory-numbers-12.mp3": 77682,
	"./no/workingmemory_numbers/workingmemory-numbers-2.mp3": 8879,
	"./no/workingmemory_numbers/workingmemory-numbers-3.mp3": 83242,
	"./no/workingmemory_numbers/workingmemory-numbers-4.mp3": 57241,
	"./no/workingmemory_numbers/workingmemory-numbers-5.mp3": 32020,
	"./no/workingmemory_numbers/workingmemory-numbers-6.mp3": 95339,
	"./no/workingmemory_numbers/workingmemory-numbers-7.mp3": 39878,
	"./no/workingmemory_numbers/workingmemory-numbers-8.mp3": 8309,
	"./no/workingmemory_numbers/workingmemory-numbers-9.mp3": 32176,
	"./no/workingmemory_words/workingmemory-words-1.mp3": 87220,
	"./no/workingmemory_words/workingmemory-words-10.mp3": 92948,
	"./no/workingmemory_words/workingmemory-words-11.mp3": 52793,
	"./no/workingmemory_words/workingmemory-words-12.mp3": 41318,
	"./no/workingmemory_words/workingmemory-words-2.mp3": 34187,
	"./no/workingmemory_words/workingmemory-words-3.mp3": 95078,
	"./no/workingmemory_words/workingmemory-words-4.mp3": 30173,
	"./no/workingmemory_words/workingmemory-words-5.mp3": 43832,
	"./no/workingmemory_words/workingmemory-words-6.mp3": 64079,
	"./no/workingmemory_words/workingmemory-words-7.mp3": 38442,
	"./no/workingmemory_words/workingmemory-words-8.mp3": 94161,
	"./no/workingmemory_words/workingmemory-words-9.mp3": 62476,
	"./se/intros/letterKnowledge-intro.mp3": 7721,
	"./se/intros/oneMinute-intro.mp3": 60049,
	"./se/intros/pd-intro.mp3": 42889,
	"./se/intros/phonemeIsolation-klarte-oppgaver.mp3": 50137,
	"./se/intros/phonemeIsolation-starter-intro.mp3": 80021,
	"./se/intros/testen-er-ferdig.mp3": 29849,
	"./se/intros/workingmemory-numbers-intro.mp3": 5492,
	"./se/intros/workingmemory-words-intro.mp3": 48849,
	"./se/rapidNaming/rapidNaming-intro1.mp3": 61997,
	"./se/rapidNaming/rapidNaming-intro2.mp3": 474,
	"./se/rapidNaming/rapidNaming-intro3.mp3": 9439,
	"./se/rapidNaming/rapidNaming-intro4.mp3": 44228,
	"./se/rapidNaming/rapidNaming-intro5.mp3": 79177,
	"./se/spoonerism/correct-1.mp3": 70174,
	"./se/spoonerism/correct-2.mp3": 19633,
	"./se/spoonerism/correct-3.mp3": 57324,
	"./se/spoonerism/incorrect-1.mp3": 22593,
	"./se/spoonerism/incorrect-2.mp3": 96654,
	"./se/spoonerism/incorrect-3.mp3": 7155,
	"./se/spoonerism/intro-end.mp3": 19840,
	"./se/spoonerism/intro.mp3": 81684,
	"./se/spoonerism/proveoppgave-1.mp3": 30386,
	"./se/spoonerism/proveoppgave-2.mp3": 97957,
	"./se/spoonerism/proveoppgave-3.mp3": 52864,
	"./se/spoonerism/spoonerism-task (1).mp3": 16163,
	"./se/spoonerism/spoonerism-task (10).mp3": 45031,
	"./se/spoonerism/spoonerism-task (11).mp3": 52404,
	"./se/spoonerism/spoonerism-task (12).mp3": 27569,
	"./se/spoonerism/spoonerism-task (13).mp3": 87054,
	"./se/spoonerism/spoonerism-task (14).mp3": 63571,
	"./se/spoonerism/spoonerism-task (15).mp3": 52336,
	"./se/spoonerism/spoonerism-task (16).mp3": 76013,
	"./se/spoonerism/spoonerism-task (17).mp3": 25962,
	"./se/spoonerism/spoonerism-task (18).mp3": 64671,
	"./se/spoonerism/spoonerism-task (19).mp3": 18060,
	"./se/spoonerism/spoonerism-task (2).mp3": 57466,
	"./se/spoonerism/spoonerism-task (20).mp3": 78712,
	"./se/spoonerism/spoonerism-task (3).mp3": 56605,
	"./se/spoonerism/spoonerism-task (4).mp3": 12132,
	"./se/spoonerism/spoonerism-task (5).mp3": 82679,
	"./se/spoonerism/spoonerism-task (6).mp3": 78558,
	"./se/spoonerism/spoonerism-task (7).mp3": 45921,
	"./se/spoonerism/spoonerism-task (8).mp3": 83992,
	"./se/spoonerism/spoonerism-task (9).mp3": 67163,
	"./se/workingmemory_numbers/workingmemory-numbers-1.mp3": 65385,
	"./se/workingmemory_numbers/workingmemory-numbers-10.mp3": 78667,
	"./se/workingmemory_numbers/workingmemory-numbers-11.mp3": 53830,
	"./se/workingmemory_numbers/workingmemory-numbers-12.mp3": 30073,
	"./se/workingmemory_numbers/workingmemory-numbers-2.mp3": 49622,
	"./se/workingmemory_numbers/workingmemory-numbers-3.mp3": 74811,
	"./se/workingmemory_numbers/workingmemory-numbers-4.mp3": 91016,
	"./se/workingmemory_numbers/workingmemory-numbers-5.mp3": 5677,
	"./se/workingmemory_numbers/workingmemory-numbers-6.mp3": 33658,
	"./se/workingmemory_numbers/workingmemory-numbers-7.mp3": 26271,
	"./se/workingmemory_numbers/workingmemory-numbers-8.mp3": 96188,
	"./se/workingmemory_numbers/workingmemory-numbers-9.mp3": 88961,
	"./se/workingmemory_words/workingmemory-words-1.mp3": 49213,
	"./se/workingmemory_words/workingmemory-words-10.mp3": 20871,
	"./se/workingmemory_words/workingmemory-words-11.mp3": 43362,
	"./se/workingmemory_words/workingmemory-words-12.mp3": 71541,
	"./se/workingmemory_words/workingmemory-words-2.mp3": 11210,
	"./se/workingmemory_words/workingmemory-words-3.mp3": 85263,
	"./se/workingmemory_words/workingmemory-words-4.mp3": 71636,
	"./se/workingmemory_words/workingmemory-words-5.mp3": 31481,
	"./se/workingmemory_words/workingmemory-words-6.mp3": 20006,
	"./se/workingmemory_words/workingmemory-words-7.mp3": 76331,
	"./se/workingmemory_words/workingmemory-words-8.mp3": 8560,
	"./se/workingmemory_words/workingmemory-words-9.mp3": 89301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46981;